'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'ufo-beam';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e048';
var svgPathData = ['M40 224c0 15.1 6.8 30 20.4 44.3 13.6 14.3 33.7 27.6 59.2 38.9 50.9 22.6 121.7 36.8 200.4 36.8s149.5-14.2 200.4-36.8c25.4-11.3 45.5-24.6 59.2-38.9 13.6-14.3 20.4-29.2 20.4-44.3s-6.8-30-20.4-44.3c-13.6-14.3-33.7-27.6-59.2-38.9-12.6-5.6-26.5-10.7-41.4-15.2 .7 6 1 12.2 1 18.4l0 19.1c0 2-.8 4-2.2 5.5-34.9 36.9-97.1 54.4-157.8 54.4s-123-17.5-157.8-54.4c-1.4-1.5-2.2-3.5-2.2-5.5l0-19.1c0-6.2 .4-12.4 1-18.4-14.9 4.5-28.8 9.6-41.4 15.2-25.4 11.3-45.5 24.6-59.2 38.9-13.6 14.3-20.4 29.2-20.4 44.3z', 'M176 144C176 64.5 240.5 0 320 0S464 64.5 464 144l0 15.8C433 190.7 377.2 207 320 207s-113-16.3-144-47.2l0-15.8zm-15-18.4c-.7 6-1 12.2-1 18.4l0 19.1c0 2 .8 4 2.2 5.5 34.9 36.9 97.1 54.4 157.8 54.4s123-17.5 157.8-54.4c1.4-1.5 2.2-3.5 2.2-5.5l0-19.1c0-6.2-.4-12.4-1-18.4 14.9 4.5 28.8 9.6 41.4 15.2 25.4 11.3 45.5 24.6 59.2 38.9 13.6 14.3 20.4 29.2 20.4 44.3s-6.8 30-20.4 44.3c-13.6 14.3-33.7 27.6-59.2 38.9-50.9 22.6-121.7 36.8-200.4 36.8s-149.5-14.2-200.4-36.8C94.2 295.9 74.1 282.6 60.4 268.3 46.8 254 40 239.1 40 224s6.8-30 20.4-44.3c13.6-14.3 33.7-27.6 59.2-38.9 12.6-5.6 26.5-10.7 41.4-15.2zm3-17.5c-18.4 5.2-35.5 11.3-50.9 18.1-26.7 11.9-48.7 26.2-64.3 42.5-15.6 16.3-24.8 35.1-24.8 55.3s9.3 39 24.8 55.3C64.4 295.6 86.4 310 113.1 321.8 166.5 345.5 239.6 360 320 360s153.5-14.5 206.9-38.2c26.7-11.9 48.7-26.2 64.3-42.5 15.6-16.3 24.8-35.1 24.8-55.3s-9.3-39-24.8-55.3c-15.5-16.3-37.6-30.6-64.3-42.5-15.4-6.9-32.5-12.9-51-18.1-16.3-71.1-79.9-124.1-155.9-124.1S180.4 37 164.1 108.1zm8.5 293.4c-3.6-2.5-8.6-1.6-11.1 2l-72 104c-2.5 3.6-1.6 8.6 2 11.1s8.6 1.6 11.1-2l72-104c2.5-3.6 1.6-8.6-2-11.1zm292.9 11.1l72 104c2.5 3.6 7.5 4.5 11.1 2s4.5-7.5 2-11.1l-72-104c-2.5-3.6-7.5-4.5-11.1-2s-4.5 7.5-2 11.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUfoBeam = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;